exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-blog-contentful-page-slug-js": () => import("./../../../src/pages/blog/{contentfulPage.slug}.js" /* webpackChunkName: "component---src-pages-blog-contentful-page-slug-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

